learnDashboardApp.factory('V3AfterStudyMessagesResource', ['$resource', ($resource) ->
  $resource "", {},
    create:
      method: 'POST'
      isArray: false
      url: APIRoutes.v3_after_study_messages_path()
])
